// Recovered compiled webpack factory 84170. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  function n(e, t) {
    if ((void 0 === t && (t = {}), t.onlyHashChange)) return void e();
    let r = document.documentElement;
    r.dataset.scrollBehavior;
    let n = r.style.scrollBehavior;
    ((r.style.scrollBehavior = "auto"),
      t.dontForceLayout || r.getClientRects(),
      e(),
      (r.style.scrollBehavior = n));
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "disableSmoothScrollDuringRouteTransition", {
      enumerable: !0,
      get: function () {
        return n;
      },
    }),
    r(94781));
}
